import React from 'react';
import './styles/PaymentPlanSchedules.scss';
import {Form, actions as formActions, Control} from 'react-redux-form';
import registeredComponent from 'utils/registeredComponent';
import { withForm, duckify, singleDuck } from 'utils/duckify';
import { Button } from 'react-bootstrap';
import { modals, paymentPlanSchedules, paymentPlanSchedulesForm } from 'ducks';
import ModalComponent from '../../ModalComponent';
import ScheduleEditor from './ScheduleEditor';
import ValidationErrors from "../../forms/ValidationErrors";
import Placeholder from "../../Placeholder";

class PaymentPlanScheduleEditor extends React.Component {
  static defaultProps = {
    paymentPlanSchedule: {},
    paymentPlanSchedulesForm: {},
    schoolYear: {},
    planForm: {},
    scheduleId: null,
    planId: null,
    saving: false,
    allDucksReady: false,
    position: null,
    shown: false
  };

  constructor(props) {
    super(props);
  };

  save() {
    const {dispatch, scheduleId, position} = this.props;
    const model = this.props.paymentPlanSchedulesForm.model;
    // updates the schedule in the original modal
    const positionKey = "paymentPlanForm.model.payment_plan_schedules[" + position + "]";
    dispatch(paymentPlanSchedulesForm.actions.save({...model}))
      // reload the payment plan to get the new associations into the original modal
      .then((response) => scheduleId ? dispatch(formActions.merge(positionKey, response))
        : dispatch(formActions.push("paymentPlanForm.model.payment_plan_schedules", response)) )
      .then(() => dispatch(modals.actions.hide('PaymentPlanScheduleEditor')))
      .catch((response) => {
        if (!response.payment_plan_schedule) {
          dispatch(modals.actions.hide());
          dispatch(modals.actions.show('UnexpectedError'));
        } else {
          dispatch(formActions.load("paymentPlanSchedulesForm.model", response.payment_plan_schedule));
        }
      })
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    const {dispatch} = this.props;
    if (prevProps.allDucksReady !== this.props.allDucksReady){
      // This weird dispatch here is to reload our form with state once it renders, so defaultValues don't wipe out state values
      dispatch(formActions.merge("paymentPlanSchedulesForm.model.schedule_items", this.props.paymentPlanSchedule.schedule_items));
    }
  }

  render() {
    const {allDucksReady, scheduleId, saving, schoolYear, planForm, paymentPlanSchedule, dispatch} = this.props;
    const scheduleForm = allDucksReady ? this.props.paymentPlanSchedulesForm.model : null;
    const buttons = [
      <Button
        variant='primary'
        disabled={saving}
        onClick={() => this.save(false)}
      >
        {saving ? 'Saving...' : 'Save'}
      </Button>
    ];

    return (
      <ModalComponent buttons={buttons} title={scheduleId ? 'Edit Schedule' : 'Create Schedule'}>
        {allDucksReady ? (
          <Form model={paymentPlanSchedulesForm.model}>
            <ValidationErrors errors={scheduleForm.errors} />
            <div className='form-horizontal'>
              <ScheduleEditor
                allDucksReady={allDucksReady}
                formDuck={paymentPlanSchedulesForm}
                formNumOfPayments={scheduleForm.number_of_payments}
                formScheduleItems={scheduleForm.schedule_items}
                databaseScheduleItems={paymentPlanSchedule.schedule_items}
                schoolYear={schoolYear}
                defaultNumPayments={parseInt(planForm.number_of_payments)}
                dispatch={dispatch}
                itemsName='schedule_items'
              />
              <Control.text model='.payment_plan_id' defaultValue={planForm ? planForm.id : 'new_schedule'} className='hide-schedule-field' />
            </div>
          </Form>
        ) : <Placeholder.loading />
        }
      </ModalComponent>
    );
  }
}

function mapDucksToProps(props) {
  const schedule = singleDuck(paymentPlanSchedules, props.scheduleId);
  return {
    paymentPlanSchedule: schedule,
    paymentPlanSchedulesForm: withForm(schedule, paymentPlanSchedulesForm)
  };
}


export default registeredComponent('PaymentPlanScheduleEditor')(duckify(mapDucksToProps)(PaymentPlanScheduleEditor));
